// Lets an admin preview the new card while impersonating a customer whose
// account doesn't have the flag. Visiting the dashboard once with
// ?preview=charge_forecast_v2 turns it on for the rest of that browser tab;
// ?preview=off turns it back off. Nothing here is sensitive: the only effect
// is which version of the forecast card renders.
const PREVIEW_PARAM = 'preview'
const PREVIEW_VALUE = 'charge_forecast_v2'
const STORAGE_KEY = 'optiwatt.preview.charge_forecast_v2'

export function isChargeForecastV2PreviewOn(): boolean {
  if (typeof window === 'undefined') {
    return false
  }

  try {
    const requested = new URLSearchParams(window.location.search).get(
      PREVIEW_PARAM,
    )
    if (requested === PREVIEW_VALUE) {
      window.sessionStorage.setItem(STORAGE_KEY, '1')
    } else if (requested === 'off') {
      window.sessionStorage.removeItem(STORAGE_KEY)
    }
    return window.sessionStorage.getItem(STORAGE_KEY) === '1'
  } catch {
    // Storage can be blocked in private browsing or inside some webviews
    return false
  }
}
